import {Pipe} from '@angular/core';

/**
 * A simple string filter, since ng2 does not yet have a filter pipe built in.
 */
@Pipe({
    name: 'stringFilter'
})
export class StringFilterPipe {

    transform(value: string[], q: string) {
        if (!q || q === '') {
            return value;
        }

        return value.filter(item => -1 < item['name'].toString().toLowerCase().indexOf(q.toString().toLowerCase()));
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/projects/stringfilter.pipe.ts